<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     btn_copy
                     @copy="handleCopy"
        >
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel">
            <template slot="footer">
                <el-button slot="reference" class="pull-left" type="warning" size="small" plain @click="handlePreview">
                    预览
                </el-button>
                <el-button slot="reference" class="pull-left" type="success" size="small" plain @click="handleTest">测试
                </el-button>
                <div class="text-muted ml-5 pull-left">
                    <small>Save before test / 保存后再测试.</small>
                </div>
            </template>

            <el-dialog :visible.sync="show_preview" append-to-body width="85%" :title="title">
                <div style="max-height: 60vh;overflow: auto">
                    <div v-html="html"></div>
                    <div class="clearfix"></div>
                </div>
                <div slot="footer">
                    <el-button @click="show_preview = false">确认</el-button>
                </div>

            </el-dialog>
        </edit-dialog>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";

    export default {
        mixins: [FrontMixins],
        name: 'admin-mail-template',
        components: {FrontTable, EditDialog},
        created() {
            this.model = 'Admin.MailTemplate';
        },
        data() {
            return {
                email: null,
                show_preview: false,
                title: '',
                html: '',
            }
        },
        methods: {
            handleTest() {
                this.$prompt('Email', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '放弃',
                    inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                    inputErrorMessage: '请提供正确的邮件地址'
                }).then(({value}) => {
                    this.$api('Admin.MailTemplate.Test', {email: value, id: this.single.id}, 1).then(() => {
                        this.$messageBox.success('OK');
                    });
                }).catch(() => {
                });
            },
            handlePreview() {
                this.$api('Admin.MailTemplate.Test', {preview: 1, single: this.single}, 1).then(({data}) => {
                    this.title = data.data.title;
                    this.html = data.data.html;
                    this.show_preview = true;
                });
            },
        }
    }

</script>

<style lang="scss">

</style>
